import { MenuItem, TextField } from '@material-ui/core';
import { ReactElement, useEffect } from 'react';
import { connect } from 'react-redux';
import { config } from '../../../config';
import {
	AppState,
	AppThunkDispatch,
	fetchAllLicences,
	Licence,
	UserActions,
	userSelectLicence
} from '../../../redux';

import './licence-switcher.styles.scss';
export interface ILicenceSwitcherProps {
	licences?: Licence[];
	selectedLicence?: Licence;
	fetchAllLicences: () => void;
	selectLicence: (licence: Licence) => void;
}

function LicenceSwitcherComponent(props: ILicenceSwitcherProps): ReactElement {
	const { licences, selectedLicence, fetchAllLicences, selectLicence } =
		props;

	const wildcardLicence: Licence = {
		name: 'Loper',
		ean: ' '
	};

	useEffect(() => {
		fetchAllLicences();
	}, []);

	useEffect(() => {
		const savedLicence: string | null = getLocalSelectedLicence();
		if (!licences || savedLicence === null) {
			selectLicence(wildcardLicence);
		} else {
			const foundLicence: Licence | undefined = licences.find(
				(x) => x.ean === savedLicence
			);
			foundLicence
				? selectLicence(foundLicence)
				: selectLicence(wildcardLicence);
		}
	}, [licences]);

	function getLocalSelectedLicence(): string | null {
		return localStorage.getItem(config.selectedLicenceLocalstorageKey);
	}

	function handleSelectLicence(licence: Licence): void {
		selectLicence(licence);
		localStorage.setItem(
			config.selectedLicenceLocalstorageKey,
			licence.ean
		);
		window.location.reload();
	}

	return (
		<>
			{licences && (
				<TextField
					select
					className="licence-switcher-select"
					variant="outlined"
					value={selectedLicence ? selectedLicence.ean : ' '}
				>
					<MenuItem
						value={wildcardLicence.ean}
						onClick={() => handleSelectLicence(wildcardLicence)}
					>
						{wildcardLicence.name}
					</MenuItem>
					{licences.map((licence: Licence, index: number) => (
						<MenuItem
							key={index}
							value={licence.ean}
							onClick={() => handleSelectLicence(licence)}
						>
							{licence.name}
						</MenuItem>
					))}
				</TextField>
			)}
		</>
	);
}

function mapStateToProps(state: AppState) {
	return {
		licences: state.licences.licences,
		selectedLicence: state.user.selectedLicence
	};
}

function mapDispatchToProps(dispatch: AppThunkDispatch<UserActions>) {
	return {
		fetchAllLicences: () => dispatch(fetchAllLicences(0, 1000)),
		selectLicence: (licence: Licence) =>
			dispatch(userSelectLicence(licence))
	};
}

export const LicenceSwitcher = connect(
	mapStateToProps,
	mapDispatchToProps
)(LicenceSwitcherComponent);
